import { BASE_API_URL } from '../constants'
import Token from "./Token";


export const SessionTieredPricingApi = {
    get: (sessionUuid) => {
        return fetch(
            BASE_API_URL + `/api/session-tiered-pricing/${sessionUuid}`,
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
}